"use client"

import SignupModal, { SignupModalRef } from "@/components/authen/signup/SignupModal"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { useIsAuthen } from "@/hooks/auth/useIsAuthen"
import { Image, Modal } from "antd"
import { useRouter } from "next/navigation"
import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react"
import ModalContactNow, { ModalContactNowRef } from "@/components/flight/flights/components/PromotionVietjet/ModalContactNow"
import { useTERouter } from "@/hooks/app/useTERouter"
import ModalCharter, { ModalCharterRef } from "@/components/common/ModalCharter"

export type PopupNewUserRef = {
  close: () => void,
  open: (src?: string, redirect?: string) => void
}

type PopupNewUserProps = {
  autoOpen?: boolean,
  src?: string
}

const PopupNewUser = forwardRef<PopupNewUserRef, PopupNewUserProps>(({ autoOpen = true }, ref) => {
  const isAuthen = useIsAuthen()
  const [open, setOpen] = useState<boolean>(false)
  const [redirect, setRedirect] = useState<string | null>(null)
  const [img, setImg] = useState<string | null>(null)
  const isDesktop = useIsDesktop()
  const refSignupModal = useRef<SignupModalRef>(null)
  const refModalContactNow = useRef<ModalContactNowRef>(null)
  const handleClose = useCallback(() => setOpen(false), [])
  const router = useTERouter()
  const refModalCharter = useRef<ModalCharterRef>(null)

  const handleOpen = useCallback((src?: string, redirect?: string) => {
    setOpen(true)
    setRedirect(redirect === 'QH_BINHNGHO2026' ? '/ve-may-bay' : (redirect || null))
    setImg(src || "/static/images/new_user_deals/popup/qh-promo-1301.png")
  }, [isAuthen])

  useEffect(() => {
    if (!isAuthen && autoOpen) {
      setOpen(true)
      setTimeout(() => {
        setOpen(false)
      }, 10000)
    }
  }, [isAuthen, autoOpen])

  useImperativeHandle(ref, () => {
    return {
      open: handleOpen,
      close: handleClose
    }
  }, [handleClose, handleOpen])

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      footer={<></>}
      // closable={false}
      className="popup_newuser_deals"
      styles={{
        container: {
          padding: 0,
          background: 'none',
          boxShadow: 'none'
        },
      }}
      width={"60rem"}
    >
      <SignupModal ref={refSignupModal} />
      <ModalContactNow ref={refModalContactNow} />
      <ModalCharter ref={refModalCharter} />
      <Image
        onClick={() => {
          handleClose()
          setTimeout(() => {
            // Check if this is the bamboo voucher popup
            if (redirect) {
              router.push(redirect)
              return;
            }
            if (!img) {
              refModalCharter.current?.open()
              return;
            }
            
          }, 400)

        }}
        style={{ borderRadius: 8 }}
        preview={false}
        src={img || "/static/images/new_user_deals/popup/qh-promo-1301.png"}
      />
    </Modal>
  )
})

export default PopupNewUser